// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — video-url.classic.js, новая — video-url.cp.js
import { isCp } from 'libs/design';
import * as classic from './video-url.classic';
import * as cp from './video-url.cp';

export const VideoUrl = isCp ? cp.VideoUrl : classic.VideoUrl;
